export default {
  noOptionsText: 'Sin elementos',
  noResultsText: 'Sin coincidencias',
  openOnFocus: true,
  searchPromptText: 'Escribe para buscar...',
  disableBranchNodes: true,
  zIndex: 1100,
  clearOnSelect: true,
  loadingText: 'Cargando...',
  limitText: count => `${count} más`
}
